import { render, staticRenderFns } from "./SettingsHelp.vue?vue&type=template&id=42928a83"
import script from "./SettingsHelp.vue?vue&type=script&lang=js"
export * from "./SettingsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports